import { FormType } from '../../../form-types';
import { SybilHRTFieldAnswers } from '../questions';

const sybilHRT: FormType<SybilHRTFieldAnswers> = {
  name: 'Sybil Menopause Questionnaire',
  questions: [
    {
      key: 'sybilHRT_sexAssignedAtBirth',
      next: {
        condition: {
          'sybilHRT_sexAssignedAtBirth.female': true
        },
        key: 'sybilHRT_height',
        els: 'sybilHRT_ineligible'
      }
    },
    'sybilHRT_height',
    'sybilHRT_weight',
    'sybilHRT_age',
    {
      key: 'sybilHRT_pregnancyConsent',
      next: {
        condition: {
          'sybilHRT_pregnancyConsent.consent': true
        },
        key: 'sybilHRT_currentOrPlanningPregnancy',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_currentOrPlanningPregnancy',
      next: {
        condition: {
          'sybilHRT_currentOrPlanningPregnancy.no': true
        },
        key: 'sybilHRT_breastfeeding',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_breastfeeding',
      next: {
        condition: {
          'sybilHRT_breastfeeding.no': true
        },
        key: 'sybilHRT_unexplainedVaginalBleeding',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_unexplainedVaginalBleeding',
      next: {
        condition: {
          'sybilHRT_unexplainedVaginalBleeding.no': true
        },
        key: 'sybilHRT_liverHealthIssues',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_liverHealthIssues',
      next: {
        condition: {
          'sybilHRT_liverHealthIssues.no': true
        },
        key: 'sybilHRT_menopauseDiagnosis',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_menopauseDiagnosis',
      next: {
        condition: {
          'sybilHRT_menopauseDiagnosis.yes': true
        },
        key: 'sybilHRT_symptoms',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_symptoms',
      next: {
        switch: [
          {
            condition: {
              'sybilHRT_symptoms.other': true
            },
            key: 'sybilHRT_additionalSymptom'
          },
          {
            condition: {
              'sybilHRT_symptoms.none': true
            },
            key: 'sybilHRT_ineligible'
          }
        ],
        els: 'sybilHRT_hormonalSymptoms'
      }
    },
    'sybilHRT_additionalSymptom',
    'sybilHRT_hormonalSymptoms',
    {
      key: 'sybilHRT_routingBetweenTreatmentType',
      next: {
        condition: {
          'sybilHRT_routingBetweenTreatmentType.none': true
        },
        key: 'sybilHRT_HRT_adhesiveAllergy',
        els: 'sybilHRT_NONHRT_RouteConsent'
      }
    },
    {
      key: 'sybilHRT_NONHRT_RouteConsent',
      next: {
        condition: {
          'sybilHRT_NONHRT_RouteConsent.consent': true
        },
        key: 'sybilHRT_NONHRT_depressionTreatment',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_NONHRT_depressionTreatment',
      next: {
        condition: {
          'sybilHRT_NONHRT_depressionTreatment.no': true
        },
        key: 'sybilHRT_NONHRT_previousMedicationForDepression',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_NONHRT_previousMedicationForDepression',
      next: {
        condition: {
          'sybilHRT_NONHRT_previousMedicationForDepression.yes': true
        },
        key: 'sybilHRT_NONHRT_previousMedicationForDepression_Details',
        els: 'sybilHRT_NONHRT_disqualifyingConditions'
      }
    },
    'sybilHRT_NONHRT_previousMedicationForDepression_Details',
    {
      key: 'sybilHRT_NONHRT_disqualifyingConditions',
      next: {
        condition: {
          'sybilHRT_NONHRT_disqualifyingConditions.none': true
        },
        key: 'sybilHRT_NONHRT_bloodThinners',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_NONHRT_bloodThinners',
      next: {
        condition: {
          'sybilHRT_NONHRT_bloodThinners.yes': true
        },
        key: 'sybilHRT_ineligible',
        els: 'sybilHRT_NONHRT_allergy'
      }
    },
    {
      key: 'sybilHRT_NONHRT_allergy',
      next: {
        condition: {
          'sybilHRT_NONHRT_allergy.yes': true
        },
        key: 'sybilHRT_ineligible',
        els: 'sybilHRT_NONHRT_HotFlashConsent'
      }
    },
    {
      key: 'sybilHRT_NONHRT_HotFlashConsent',
      next: {
        condition: {
          'sybilHRT_NONHRT_HotFlashConsent.consent': true
        },
        key: 'sybilHRT_HRT_questions_for_doctor',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_HRT_adhesiveAllergy',
      next: {
        condition: {
          'sybilHRT_HRT_adhesiveAllergy.yes': true
        },
        key: 'sybilHRT_HRT_FormulationPreferred',
        els: 'sybilHRT_HRT_estradiolPreference'
      }
    },
    {
      key: 'sybilHRT_HRT_FormulationPreferred',
      next: {
        key: 'sybilHRT_HRT_hrt_status'
      }
    },

    'sybilHRT_HRT_estradiolPreference',

    {
      key: 'sybilHRT_HRT_hrt_status',
      next: {
        condition: {
          'sybilHRT_HRT_hrt_status.never_taken': true
        },
        key: 'sybilHRT_HRT_oophorectomy',
        els: 'sybilHRT_HRT_hrt_formulation'
      }
    },
    'sybilHRT_HRT_hrt_formulation',
    {
      key: 'sybilHRT_HRT_hrt_side_effects',
      next: {
        condition: {
          'sybilHRT_HRT_hrt_side_effects.yes': true
        },
        key: 'sybilHRT_HRT_side_effects_details',
        els: 'sybilHRT_HRT_transdermal_side_effects'
      }
    },
    'sybilHRT_HRT_side_effects_details',
    {
      key: 'sybilHRT_HRT_transdermal_side_effects',
      next: {
        condition: {
          'sybilHRT_HRT_transdermal_side_effects.yes': true
        },
        key: 'sybilHRT_HRT_transdermal_reaction_details',
        els: 'sybilHRT_HRT_oophorectomy'
      }
    },
    'sybilHRT_HRT_transdermal_reaction_details',
    {
      key: 'sybilHRT_HRT_oophorectomy',
      next: {
        condition: {
          'sybilHRT_HRT_oophorectomy.yes': true
        },
        key: 'sybilHRT_HRT_oophorectomy_details',
        els: 'sybilHRT_HRT_vaginal_symptoms'
      }
    },
    'sybilHRT_HRT_oophorectomy_details',
    {
      key: 'sybilHRT_HRT_vaginal_symptoms',
      next: {
        condition: {
          'sybilHRT_HRT_vaginal_symptoms.none': true
        },
        key: 'sybilHRT_HRT_risk_factors',
        els: 'sybilHRT_HRT_vaginal_estrogen_preference'
      }
    },
    'sybilHRT_HRT_vaginal_estrogen_preference',
    'sybilHRT_HRT_risk_factors',
    {
      key: 'sybilHRT_HRT_hysterectomy',
      next: {
        condition: {
          'sybilHRT_HRT_hysterectomy.yes': true
        },
        key: 'sybilHRT_HRT_hysterectomy_details',
        els: 'sybilHRT_HRT_sleep_breast_tenderness'
      }
    },
    'sybilHRT_HRT_hysterectomy_details',
    {
      key: 'sybilHRT_HRT_sleep_breast_tenderness',
      next: {
        condition: {
          'sybilHRT_HRT_sleep_breast_tenderness.yes': true
        },
        key: 'sybilHRT_HRT_bone_health',
        els: 'sybilHRT_HRT_current_medications'
      }
    },
    'sybilHRT_HRT_bone_health',
    {
      key: 'sybilHRT_HRT_current_medications',
      next: {
        condition: {
          'sybilHRT_HRT_current_medications.none': true
        },
        key: 'sybilHRT_HRT_blood_pressure',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_HRT_blood_pressure',
      next: {
        condition: {
          'sybilHRT_HRT_blood_pressure.high': true
        },
        key: 'sybilHRT_ineligible',
        els: 'sybilHRT_HRT_diabetes'
      }
    },
    'sybilHRT_HRT_diabetes',
    {
      key: 'sybilHRT_HRT_thyroid_dysfunction',
      next: {
        condition: {
          'sybilHRT_HRT_thyroid_dysfunction.yes': true
        },
        key: 'sybilHRT_HRT_thyroid_details',
        els: 'sybilHRT_HRT_family_history'
      }
    },
    'sybilHRT_HRT_thyroid_details',
    'sybilHRT_HRT_family_history',
    {
      key: 'sybilHRT_HRT_uterine_fibroids',
      next: {
        condition: {
          'sybilHRT_HRT_uterine_fibroids.yes': true
        },
        key: 'sybilHRT_HRT_fibroid_consent',
        els: 'sybilHRT_HRT_pcos'
      }
    },
    {
      key: 'sybilHRT_HRT_fibroid_consent',
      next: {
        condition: {
          'sybilHRT_HRT_fibroid_consent.consent': true
        },
        key: 'sybilHRT_HRT_pcos',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_HRT_pcos',
      next: {
        condition: {
          'sybilHRT_HRT_pcos.yes': true
        },
        key: 'sybilHRT_HRT_pcos_consent',
        els: 'sybilHRT_HRT_endometriosis'
      }
    },
    {
      key: 'sybilHRT_HRT_pcos_consent',
      next: {
        condition: {
          'sybilHRT_HRT_pcos_consent.consent': true
        },
        key: 'sybilHRT_HRT_endometriosis',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_HRT_endometriosis',
      next: {
        condition: {
          'sybilHRT_HRT_endometriosis.yes': true
        },
        key: 'sybilHRT_HRT_endometriosis_consent',
        els: 'sybilHRT_HRT_continued_screening_consent'
      }
    },
    {
      key: 'sybilHRT_HRT_endometriosis_consent',
      next: {
        condition: {
          'sybilHRT_HRT_endometriosis_consent.consent': true
        },
        key: 'sybilHRT_HRT_continued_screening_consent',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_HRT_continued_screening_consent',
      next: {
        condition: {
          'sybilHRT_HRT_continued_screening_consent.consent': true
        },
        key: 'sybilHRT_HRT_questions_for_doctor',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_HRT_questions_for_doctor',
      next: {
        condition: { 'sybilHRT_routingBetweenTreatmentType.none': true },
        key: 'sybilHRT_HRT_main_consent',
        els: 'sybilHRT_truthfulness_consent'
      }
    },
    {
      key: 'sybilHRT_HRT_main_consent',
      next: {
        condition: {
          'sybilHRT_HRT_main_consent.consent': true
        },
        key: 'sybilHRT_truthfulness_consent',
        els: 'sybilHRT_ineligible'
      }
    },
    {
      key: 'sybilHRT_truthfulness_consent',
      next: {
        condition: {
          'sybilHRT_truthfulness_consent.consent': true
        },
        key: 'sybilHRT_complete',
        els: 'sybilHRT_ineligible'
      }
    },
    'sybilHRT_complete',
    'sybilHRT_ineligible'
  ]
};

export default sybilHRT;
